<template>
  <div class>
    <!-- <div class="row margin-top-15">
      <div class="col-md-8">
        <p>Redirecționează până la 20% din impozitul pe profit pe anul în curs către Asociația Recorder Community. În loc să ajungă la stat, banii tăi se transformă în sprijin financiar pentru realizarea materialelor Recorder.</p>
        <p>Completează mai jos datele firmei, generează contractul, semnează-l și trimite-l scanat la office@recorder.ro. Dacă ai întrebări, scrie-ne la aceeași adresă și îți vom răspunde cât mai curând posibil. Mulțumim!</p>
      </div>
    </div> -->
    <div class="row">
      <div class="col-md-4 margin-top-15">
        <form-input
          input-type="text"
          input-name="cui"
          :input-label="cuiLabel"
          :input-value="cui"
          :set-input="onInputCui"
          :isValid="isValidCui"
          :error-text="cuiError"
        ></form-input>
      </div>
      <div class="col-md-8 margin-top-42">
        <button-form button-name="CAUTĂ" :on-click="goToWizard"></button-form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 margin-top-15">
        <p class="error" v-if="isServiceError">
          Serviciul ANAF este indisponibil momentan. 
          <button @click="proceedManually" class="btn-link">Completează datele manual</button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import { CUI_INVALID } from "../../content/FormErrors.js";
import { CUI_LABEL } from "../../content/FormLabels.js";
import { validateCui } from "../../helpers/Validations.js";
import ButtonForm from "../global/ButtonForm";
import FormInput from "../global/FormInput";

export default {
  components: {
    FormInput,
    ButtonForm
  },
  data() {
    return {
      cuiLabel: CUI_LABEL,
      cuiError: CUI_INVALID
    };
  },
  computed: {
    ...mapState({
      cui: state => state.formInputs.cui,
      isValidCui: state => state.isFormValid.cui,
      isServiceError: state => state.isServiceError
    })
  },
  methods: {
    ...mapMutations([
      "addCompanyName",
      "addCui",
      "addAddress",
      "addRegisterNum",
      "setIsServiceError",
      "isCuiValid",
      "incrementWizardStep"
    ]),
    onInputCui: function(event) {
      if (this.cui !== event.target.value.trim())
        this.addCui(event.target.value.trim());
    },
    goToWizard: function(event) {
      this.setIsServiceError(false);
      const isCuiValid = validateCui(this.cui);
      this.isCuiValid(isCuiValid);
      if (isCuiValid) this.getCompanyData();
    },
    proceedManually: function() {
      // Reset error state and proceed to next step with manual data entry
      this.setIsServiceError(false);
      this.incrementWizardStep();
    },
    getCompanyData: async function() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const formattedDate = year + "-" + month + "-" + day;

      const addAddress = this.addAddress;
      const addRegisterNum = this.addRegisterNum;
      const addCompanyName = this.addCompanyName;
      const setIsServiceError = this.setIsServiceError;
      const incrementWizardStep = this.incrementWizardStep;

      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: "/wp-content/themes/recorder/template-parts/formular/getCui.php",
        data: JSON.stringify({
          cui: this.cui,
          date: formattedDate
        })
      }).then(function(response) {
        if (response.data.success === true) {
          addAddress(response.data.obj.address);
          addRegisterNum(response.data.obj.registerNo);
          addCompanyName(response.data.obj.companyName);
          incrementWizardStep();
        } else {
          setIsServiceError(true);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  font-size: 1rem;
}

.error {
  color: #bd1f23;
}

.btn-link {
  background: none;
  border: none;
  color: #0066cc;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  margin-left: 0.5rem;
  font-size: 1rem;
  
  &:hover {
    color: #004499;
  }
}
</style>
